import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { OrgAndStockroomService } from '@core/services/org-and-stockroom/org-and-stockroom-api';
import { PrivilegeService } from '@core/services/privilege/privilege-api';
import { AppState } from '@core/store/reducers/common.reducer';
import { getPrivileges } from '@core/store/selectors/common.selectors';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { AppService } from '../../services/app/app-api';
import { CanActivate, CanActivateChild } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class PrivilegeGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router,
    private privilegeService: PrivilegeService,
    private orgAndStockroomService: OrgAndStockroomService,
    private appService: AppService,
    private store: Store<AppState>
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.store.select(getPrivileges).pipe(take(1)).subscribe((privileges: any) => {
      // ACTIVITY LOG
      if (route.routeConfig?.path === 'stockroom-activity-log' || route.routeConfig?.path === 'article-activity-log' || route.routeConfig?.path === 'site-activity-log') {
        if (this.privilegeService.findPrivelege('priv_overview_activitylog_icon', privileges)) {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // LOCATION MAINTENANCE
      if (route.routeConfig?.path === 'administration/location-maintenance') {
        if (this.privilegeService.findPrivelege('priv_setup_location_maintenance_icon', privileges)) {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // RECEIVE STOCK
      if (route.routeConfig?.path === 'activities/receive-stock') {
        if (this.privilegeService.findPrivelege('priv_receive_stock_icon', privileges)) {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // CREATE BARCODES
      if (route.routeConfig?.path === 'activities/create-barcodes') {
        if (this.privilegeService.findPrivelege('priv_create_barcode_icon', privileges)) {

          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // STOCKROOM CORRECTION
      if (route.routeConfig?.path === 'activities/stock-correction') {
        if (this.privilegeService.findPrivelege('priv_administer_stock_icon', privileges)) {

          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // MANAGE STOCKROOM
      if (route.routeConfig?.path === 'administration/manage-stockroom') {
        if (this.privilegeService.findPrivelege('priv_setup_manage_stockroom_icon', privileges)) {

          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // REASON CODE MAINTENANCE
      if (route.routeConfig?.path === 'administration/reason-code-maintenance') {
        if (this.privilegeService.findPrivelege('priv_setup_reason_code_maintenance_icon', privileges)) {

          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // PRODUCT MAINTENANCE
      if (route.routeConfig?.path === 'administration/product-maintenance') {
        if (this.privilegeService.findPrivelege('priv_setup_product_maintenance_icon', privileges)) {

          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // USER MAINTENANCE
      if (route.routeConfig?.path === 'administration/user-maintenance') {
        if (this.privilegeService.findPrivelege('priv_setup_user_maintenance_icon', privileges)) {

          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // CONSUME STOCK
      if (route.routeConfig?.path === 'activities/consume-stock') {
        if (this.privilegeService.findPrivelege('priv_consume_stock_icon', privileges)) {

          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // OVERVIEW (All 3 sub nav)
      if (route.routeConfig?.path === 'overview/requests' || route.routeConfig?.path === 'overview/orders' || route.routeConfig?.path === 'overview/products') {
        if (this.privilegeService.findPrivelege('priv_overview_icon', privileges)) {

          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // APPROVAL
      if (route.routeConfig?.path === 'activities/approval') {
        if (this.privilegeService.findPrivelege('priv_approval_icon', privileges)) {

          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }


      // REPLENISH STOCK CONSUMPTION MODE
      if (route.routeConfig?.path === 'activities/replenish-stock') {
        let replenishModel;
        const currentOrgStockroom = this.orgAndStockroomService.getStockroomAndOrgName();
        if (currentOrgStockroom) {
          const data = JSON.parse(currentOrgStockroom);
          replenishModel = data.organization.replenishModel;
        }
        if (replenishModel === 'CONSUMPTION_MODEL' || localStorage.getItem('vwrFromSearch')) {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // REPLENISH STOCK PUT AWAY
      if (route.routeConfig?.path === 'activities/replenish-stock-put-away') {
        let replenishModel;
        const currentOrgStockroom = this.orgAndStockroomService.getStockroomAndOrgName();
        if (currentOrgStockroom) {
          const data = JSON.parse(currentOrgStockroom);
          replenishModel = data.organization.replenishModel;
        }
        if (replenishModel === 'PUTAWAY_MODEL') {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // REPLENISH STOCK ON HAND
      if (route.routeConfig?.path === 'activities/replenish-stock-on-hand') {
        let replenishModel;
        const currentOrgStockroom = this.orgAndStockroomService.getStockroomAndOrgName();
        if (currentOrgStockroom) {
          const data = JSON.parse(currentOrgStockroom);
          replenishModel = data.organization.replenishModel;
        }
        if (replenishModel === 'ON_HAND_MODEL') {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // REPLENISH STOCK Issuance
      if (route.routeConfig?.path === 'activities/replenish-stock-issuance') {
        let replenishModel;
        const currentOrgStockroom = this.orgAndStockroomService.getStockroomAndOrgName();
        if (currentOrgStockroom) {
          const data = JSON.parse(currentOrgStockroom);
          replenishModel = data.organization.replenishModel;
        }
        if (replenishModel === 'ISSUANCE_MODEL') {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // DOWNLOAD CENTER
      if (route.routeConfig?.path === 'download-center') {
        if (this.privilegeService.findPrivelege('priv_download_softwares_icon', privileges) || this.privilegeService.findPrivelege('priv_download_documents_icon', privileges)) {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      if (route.routeConfig?.path === 'activities/scanner-replenish/on-hand' || route.routeConfig?.path === 'activities/scanner-replenish/put-away') {
        const userData: any = this.appService.getUserData();
        if (this.privilegeService.findPrivelege('priv_palm_run_report_icon', privileges) && userData.userType != 'IMSS_USER' && userData.isImssUser != 1) {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }
      // DO NOT REMOVE! FOR EV2.
      // if (route.routeConfig?.path === 'download-center') {
      //   if (this.privilegeService.findPrivelege('priv_download_softwares_icon')
      //     || this.privilegeService.findPrivelege('priv_download_documents_icon')) {
      //     return true;
      //   } else {
      //     this.router.navigate([this.router.url]);
      //   }
      // }

      // REPORTING
      if (route.routeConfig?.path === 'overview/reporting') {
        if (this.privilegeService.findPrivelege('priv_overview_report_icon', privileges)
          && this.privilegeService.findChildPrivelege('priv_use_reports', privileges)) {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // INTERGARTION MAINTENANCE
      if (route.routeConfig?.path === 'administration/integration-maintenance') {
        if (this.privilegeService.findPrivelege('priv_setup_integrations_icon', privileges)) {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }


      // VENDOR MAINTENANCE
      if (route.routeConfig?.path === 'administration/vendor-maintenance') {
        if (this.privilegeService.findPrivelege('priv_setup_vendor_maintenance_icon', privileges)) {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      // EXPORT IMPORT STOCK
      if (route.routeConfig?.path === 'administration/export-import-stockroom') {
        if (this.privilegeService.findPrivelege('priv_setup_import_export_stock_icon', privileges)) {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      //REFERANCE CODE
      if (route.routeConfig?.path === 'administration/reference-codes') {
        if (this.privilegeService.findPrivelege('priv_setup_reference_code_maintenance_icon', privileges)) {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      //COST CENTER MAINTENANCE
      if (route.routeConfig?.path === 'administration/cost-center-maintenance') {
        if (this.privilegeService.findPrivelege('priv_setup_cost_center_maintenance_icon', privileges)) {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      //DEPARTMENT MAINTENANCE
      if (route.routeConfig?.path === 'administration/department-maintenance') {
        if (this.privilegeService.findPrivelege('priv_setup_department_maintenance_icon', privileges)) {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }

      //MESSAGE CENTER
      if (route.routeConfig?.path === 'administration/message-center') {
        if (this.privilegeService.findPrivelege('priv_setup_message_center_icon', privileges)) {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }



      // TRACK ORDER
      if (route.routeConfig?.path === 'track-orders' || route.routeConfig?.path === 'track-orders/monitor-consignment-stock-correction' || route.routeConfig?.path === 'track-orders/ke-order-tracking') {
        if (this.privilegeService.findPrivelege('priv_order_tracking_icon', privileges)) {
          return true;
        } else {
          this.router.navigate([this.router.url]);
        }
      }
      return true;
    })

    return true;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {


    // DOWNLOAD CENTER
    if (childRoute.routeConfig?.path === 'software-and-manuals') {
      if (this.privilegeService.findPrivelege('priv_download_softwares_icon')) {
        return true;
      }
      // DO NOT REMOVE! FOR EV2.
      else {
        this.router.navigate(['app/download-center/documents']);
      }
    }

    // DO NOT REMOVE! FOR EV2.
    if (childRoute.routeConfig?.path === 'documents') {
      if (this.privilegeService.findPrivelege('priv_download_documents_icon')) {
        return true;
      } else {
        this.router.navigate(['app/download-center/software-and-manuals']);
      }
    }

    // REPORTING
    if (childRoute.routeConfig?.path === 'report/:reportId/edit'
      || childRoute.routeConfig?.path === 'add-report-template') {
      if (this.privilegeService.findPrivelege('priv_edit_reports')) {
        return true;
      }
    }
    return false;

  }

}
